import React from "react";
import { LegalLayout, LegalSection } from "./legal/LegalLayout";

export default function ConfidentialitePage() {
  return (
    <LegalLayout
      testid="confidentialite-page"
      eyebrow="RGPD · Vie privée"
      title="Politique de confidentialité"
    >
      <LegalSection title="Responsable du traitement" testid="section-responsable">
        <p>
          <strong className="text-slate-100">Olivier Girault</strong>, 38 rue Édouard
          Pied, 79450 Saint-Aubin-le-Cloud.
          <br />
          Contact :{" "}
          <a
            href="mailto:olivier3835@gmail.com"
            className="text-cyan-300 hover:text-cyan-200 hover:underline"
          >
            olivier3835@gmail.com
          </a>
        </p>
      </LegalSection>

      <LegalSection title="Données collectées" testid="section-donnees">
        <p>Le site collecte :</p>
        <ul className="list-disc space-y-2 pl-5">
          <li>
            La plaque d'immatriculation que vous saisissez, afin d'identifier votre
            véhicule et les pièces compatibles.
          </li>
          <li>
            Les données techniques de navigation (adresse IP, type de navigateur) et
            les cookies.
          </li>
          <li>
            Le cas échéant, l'adresse e-mail que vous communiquez via le formulaire
            de contact.
          </li>
        </ul>
      </LegalSection>

      <LegalSection title="Finalités" testid="section-finalites">
        <p>
          Ces données servent à identifier votre véhicule, afficher les pièces et
          offres correspondantes, assurer le fonctionnement du comparateur et des
          liens d'affiliation, et répondre à vos demandes.
        </p>
      </LegalSection>

      <LegalSection title="Base légale" testid="section-base-legale">
        <p>
          Le traitement repose sur votre consentement (cookies et saisie de la
          plaque) et sur l'intérêt légitime de l'éditeur à fournir le service.
        </p>
      </LegalSection>

      <LegalSection title="Cookies" testid="section-cookies">
        <p>
          Le site utilise des cookies de fonctionnement et des cookies
          d'affiliation, qui permettent d'attribuer un achat réalisé chez un
          partenaire. Un bandeau vous permet d'accepter ou refuser les cookies non
          essentiels.
        </p>
      </LegalSection>

      <LegalSection title="Durée de conservation" testid="section-conservation">
        <p>
          La plaque d'immatriculation n'est pas conservée au-delà de la session de
          recherche, sauf si vous l'enregistrez dans votre historique. Les autres
          données sont conservées le temps nécessaire à la finalité, puis supprimées.
        </p>
      </LegalSection>

      <LegalSection title="Partage des données" testid="section-partage">
        <p>
          Vos données ne sont pas vendues. Les liens d'affiliation peuvent
          transmettre des informations techniques aux plateformes partenaires, selon
          leurs propres politiques.
        </p>
      </LegalSection>

      <LegalSection title="Vos droits" testid="section-droits">
        <p>
          Conformément au RGPD, vous disposez d'un droit d'accès, de rectification,
          d'effacement, d'opposition et de portabilité. Pour les exercer, écrivez à{" "}
          <a
            href="mailto:olivier3835@gmail.com"
            className="text-cyan-300 hover:text-cyan-200 hover:underline"
          >
            olivier3835@gmail.com
          </a>
          . Vous pouvez aussi saisir la CNIL.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
